import '@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table';
import '@jack-henry/jh-icons/icons-wc/icon-arrow-rotate-right.js';
import '@jack-henry/jh-ui/components/button/button.js';
import '@jack-henry/jh-ui/components/switch/switch.js';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/services/dialog/tm-dialog';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { companyUsersTagName as tagName } from './company-users.types';

@customElement(tagName)
export class CompanyUsers extends TmBaseComponent {
    public render() {
        return html`<slot></slot>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CompanyUsers;
    }
}
